import { Flex, TabProps, Text, Tooltip } from "@mantine/core";

import ActionIcon from "../../components/ActionIcon/ActionIcon.tsx";
import SvgAlert from "../../components/Icons/Alert.tsx";
import { RolePermission } from "../../graphql/generated.ts";
import { CurrentUser, User } from "../../types/user.ts";
import { hasPermission, isBababosTenant } from "../../utils/user.ts";

interface Tab extends TabProps {
  label: string;
  show?: (user: User | null | undefined) => boolean;
}

export enum TabValue {
  CompanyInfo = "companyInfo",
  PengurusInfo = "pengurusInfo",
  ClikResult = "clikResult",
  LimitInfo = "limitInfo",
  TransactionHistory = "transactionHistory",
  InvoicesHistory = "invoicesHistory",
  LateFee = "lateFee",
}

export const getTabs = ({
  user,
  isCustomerDirectorInfoEmpty,
}: {
  user: CurrentUser | null | undefined;
  isCustomerDirectorInfoEmpty: boolean;
}): Tab[] => {
  const tabs = [
    {
      value: TabValue.CompanyInfo,
      label: "Company Info",
      children: isCustomerDirectorInfoEmpty ? (
        <Tooltip
          label={<Text size="sm">Director In Charge info is empty!</Text>}
          withinPortal
          multiline
          position="bottom-start"
          style={{ fontSize: "16px" }}
          withArrow
          arrowSize={10}
        >
          <Flex justify="space-between" align="center" gap={6}>
            Company Info{" "}
            <ActionIcon variant="error" withBorder={false}>
              <SvgAlert />
            </ActionIcon>
          </Flex>
        </Tooltip>
      ) : undefined,
      show: (user: User | null | undefined) =>
        hasPermission(user, RolePermission.CanViewBuyerInfoCompanyInfo),
    },
    {
      value: TabValue.PengurusInfo,
      label: "Pengurus Info",
      show: (user: User | null | undefined) =>
        hasPermission(user, RolePermission.CanViewBuyerInfoPengurusInfo),
    },
    {
      value: TabValue.ClikResult,
      label: "CLIK Result",
      show: (user: User | null | undefined) =>
        hasPermission(user, RolePermission.CanViewClikResult),
    },
    {
      value: TabValue.LimitInfo,
      label: "Limit Info",
      show: (user: User | null | undefined) =>
        hasPermission(user, RolePermission.CanViewBuyerInfoLimitInfo, true),
    },
    {
      value: TabValue.TransactionHistory,
      label: "Transaction History",
      show: (user: User | null | undefined) =>
        hasPermission(user, RolePermission.CanViewTransactionHistory, true),
    },
    {
      value: TabValue.InvoicesHistory,
      label: "Invoices History",
      show: (user: User | null | undefined) => isBababosTenant(user),
    },
    {
      value: TabValue.LateFee,
      label: "Late Fee",
      show: (user: User | null | undefined) => isBababosTenant(user),
    },
  ];
  return tabs.filter((item) => (item.show ? item.show(user) : true));
};
